import { CommonModule as NgCommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SecureImagePipe } from '../common/pipes/secure-image/secure-image.pipe';

import { BrowserModule } from '@angular/platform-browser';
//import { HotTableModule } from '@handsontable/angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgSelectModule } from '@ng-select/ng-select';
//import { PlotlyViaWindowModule } from 'angular-plotly.js';
//========================================================================= Local Modules
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgxSelectModule } from 'ngx-select-ex';
import { AuthModule } from '../auth/auth.module';
import { JftCommonModule } from '../common/common.module';
import { ErrorReviewGridComponent } from '../common/components/error-review-grid/error-review-grid.component';
import { GeodataModule } from '../geodata/geodata.module';
import { IndexesModule } from '../indexes/indexes.module';

import {
  AwardedContractsResolver,
  AwardedOffersResolver,
  buyerModuleRoutes,
  NewRoundGuard,
  ProposalStepGuard,
  SupplierBidResolver,
  SupplierCommonDocumentsResolver,
  SupplierContractResolver,
  SupplierContractsResolver,
  SupplierOfferBidResolver,
  SupplierProposalResolver,
  SupplierRequestedDocumentsResolver,
  SupplierResolver,
  SupplierSkippedContractsResolver,
  SuppliersResolver,
  SuppliersTabsResolver,
  SupplierSubmittedContractsResolver,
  TenderAnalyticsConversionFactor2Resolver,
  TenderUnitRatesResolver,
  TenderAnalyticsConversionFactorResolver,
  TenderAnalyticsCostOfCapitalResolver,
  TenderAnalyticsCurrencyRatesResolver,
  TenderAnalyticsInputCurrentContractResolver,
  TenderAnalyticsLocationInputCurrentContractResolver,
  TenderAnalyticsPaymentTermsResolver,
  TenderBidHistoryResolver,
  TenderBidsResolver,
  TenderContractBidsAnalysisResolver,
  TenderContractBidsDashboardResolver,
  TenderContractDashboardResolver,
  TenderContractResolver,
  TenderContractRoundIndexPriceAverageResolver,
  TenderContractRoundResolver,
  TenderContractRoundSupplierResolver,
  TenderContractsAllResolver,
  TenderContractsAwaitingBidsResolver,
  TenderContractsAwaitingReviewResolver,
  TenderContractsAwardedResolver,
  TenderContractsCancelledResolver,
  TenderContractsExpiredResolver,
  TenderContractsResolver,
  TenderContractsStatisticResolver,
  TenderContractSuppliersResolver,
  TenderCoverLetterOfferDetailResolver,
  TenderCoverLetterResolver,
  TenderDocumentsOfferDetailResolver,
  TenderDocumentsResolver,
  TenderInvitedSupplierUsersResolver,
  TenderLastRoundsSuppliersResolver,
  TenderListResolver,
  TenderOfferResolver,
  TenderRequestedDocumentsResolver,
  TenderResolver,
  TenderRevisionResolver,
  TenderStatusGuard,
  TenderStepGuard,
  TenderSupplierInputBidResolver,
  TenderSuppliersResolver
} from './routing';

import {
  AwardedContractsService, AwardedOffersService,
  ContractProductServiceService,
  ProposalService,
  SupplierBidService,

  SupplierContractService,
  SupplierContractsService,
  SupplierCoverLetterService,



  SuppliersService,
  SupplierSupplyConditionsService,
  TenderAnalyticsSettingsCurrencyRatesService,
  TenderAnalyticsSettingsService,
  TenderBidCopyToCurrentRoundService,
  TenderBidHistoryService,
  TenderBidMockService,
  TenderBidsService,
  TenderBidXlsImportService,
  TenderContractBidsAnalysisService,
  TenderContractBidsDashboardService,
  TenderContractExtendRoundService,
  TenderContractOffersService,
  TenderContractPlattsOffersService,
  TenderContractRoundIndexPriceAverageService,
  TenderContractRoundService,
  TenderContractRoundSupplierService,
  TenderContractsAwardedService,
  TenderContractsService,
  TenderContractsStatisticService,
  TenderContractSuppliersService,
  TenderDocumentsService,
  TenderEditableFieldService,
  TenderImportsService,
  TenderLaunchingXlsExportService,
  TenderNoteService,
  TenderOfferNoteService,
  TenderOffersService,
  TenderReportService,
  TenderRevisionService,
  TenderService,
  TendersService,
  TenderSupplierDocumentsService,
  TenderSupplierInvitationInfoService,
  TenderSuppliersService,
  TenderXmlExportsService,
  TenderXmlImportsService
} from './services';

import {
  ContractDashboardComponent,
  ContractNavbarComponent,
  CreateTenderComponent,
  CreateTenderStepsComponent,
  RoundControlsComponent,
  TenderBidImportModalComponent,
  TenderComponent,
  TenderContractBidsComponent,
  TenderTabsComponent
} from './layouts';

import {
  AddIndexModalComponent,
  AiportDeliveryMethodsComponent,
  ArgusIndexComponent,
  AwardButtonComponent,
  AwardCompleteModalComponent,
  BidHideShowModalComponent,
  ChartIndexAnalyticsComponent,
  ChartIndexAnalyticsGraphComponent,

  DeclineOfferButtonComponent,
  DeleteTenderButtonComponent,
  DifferentialInputComponent,



  ExtendRoundButtonComponent,
  ExtendTenderAllRoundsButtonComponent,
  GrossNetBillingComponent,
  IndexDateRangeComponent,
  IndexSearchComponent,
  InfoModalComponent,
  InfoModalTenderExistsComponent,
  InputCurrentContractModalComponent,
  InternalNotesModalComponent,
  LaunchNextRoundAllLocationsButtonComponent,
  PerUsageFeesComponent,
  PlattsChartComponent,
  PlattsIndexComponent,
  PlattsSpreadChartComponent,
  RampLimitationsComponent,
  RevisionModelSettingsModalComponent,
  RevisionViewSettingsModalComponent,
  SpreadChartComponent, TenderImportModalComponent,
  TenderNoteComponent,
  VaDisplaySettingsModalComponent
} from './components';

import { DragDropModule } from "@angular/cdk/drag-drop";
import { NgIconComponent } from "@ng-icons/core";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { NgxPaginationModule } from "ngx-pagination";


import { SubmissionFooterComponent } from "../supplier/components/submission-footer/submission-footer.component";
import {
  EditContractConditionsBtnComponent
} from "./components/edit-contract-conditions-btn/edit-contract-conditions-btn.component";
import {
  PdfBifAnalysisReportModalComponent
} from "./components/pdf-bif-analysis-report-modal/pdf-bif-analysis-report-modal.component";
import { RevisionConversionParamsModalComponent } from './components/revision-conversion-params-modal/revision-conversion-params-modal.component';
import { RevisionCurrenciesConversionComponent } from './components/revision-currencies-conversion/revision-currencies-conversion.component';
import { RevisionFinalBaseAmountComponent } from './components/revision-final-base-amount/revision-final-base-amount.component';
import { RevisionTabModelComponent } from './components/revision-tab-model/revision-tab-model.component';
import { RevisionTabModelsComponent } from './components/revision-tab-models/revision-tab-models.component';
import { RevisionTendersComparisonComponent } from './components/revision-tenders-comparison/revision-tenders-comparison.component';
import { RevisionUnitsConversionComponent } from './components/revision-units-conversion/revision-units-conversion.component';
import { SealedTenderRedirectComponent } from "./components/sealed-tender-redirect/sealed-tender-redirect.component";
import {
  ContractFormModalComponent,
  ContractsImportModalComponent,
  ContractsImportTableModalComponent,
  ConversionFactorsComponent,
  CostOfCapitalComponent,
  CreateSupplierBunchFileModalComponent,
  CreateSupplierBunchTableModalComponent,
  CreateSupplierFormComponent,
  CreateSupplierFormModalComponent,
  CreateTenderContractsComponent,
  CreateTenderDetailsComponent,
  CreateTenderReviewComponent,
  CreateTenderSuppliersComponent,
  EditProductServiceModalComponent,
  ImportContactsModalComponent,
  InputBidStepsComponent,
  InputCurrentContractComponent,
  InvitationDocumentsListComponent,
  InvitationInfoModalComponent,
  PaymentTermsComponent,
  ProductServiceModalComponent,

  SuppliersComponent,
  TenderAnalyticsSettingsComponent,
  TenderBidsComponent,
  TenderBidsSearchBarComponent,
  TenderContractBidsAnalysisComponent,
  TenderContractDashboardComponent,
  TenderContractDashboardIndexAnalysisComponent,
  TenderContractDashboardIndexAnalysisGraphComponent,
  TenderContractDashboardIndexAnalysisListComponent,
  TenderContractDashboardIndexAnalysisYearsComponent,
  TenderContractDashboardSupplierAwardedComponent,
  TenderContractDashboardSupplierComponent,
  TenderContractsAllComponent,
  TenderContractsAwaitingBidsComponent,
  TenderContractsAwaitingReviewComponent,
  TenderContractsAwardedComponent,
  TenderContractsCancelledComponent,
  TenderContractsExpiredComponent,
  TenderCurrentContractComponent,
  TenderInvitationComponent,
  TenderReportComponent,
  TenderReportsComponent,
  TendersComponent,
  TenderSearchBarComponent,
  TendersListComponent,
  TenderSupplierInputBidComponent,
  TenderSuppliersComponent,
  TenderSuppliersSearchBarComponent
} from './pages';
import { AwardedContractsComponent } from "./pages/awarded-contracts";
import { BidAnalysisReportComponent } from "./pages/bid-analysis-report/bid-analysis-report.component";
import { BidFeeReportComponent } from "./pages/bid-fee-report/bid-fee-report.component";
import { AddInvitedSuppliersFormModalComponent } from "./pages/create-tender-suppliers";
import { SupplierTableRowComponent } from "./pages/suppliers";
import { SupplierCreateRoutingComponent } from "./pages/suppliers/supplier-create-routing.component";
import { TenderAwardsSearchBarComponent } from "./pages/tender-awards/components/tender-awards-search-bar/tender-awards-search-bar.component";
import { TenderAwardsComponent } from "./pages/tender-awards/tender-awards.component";
import { AwardCommentIconComponent } from '../common/components/award-comment-icon/award-comment-icon.component';
import { EditAwardModalComponent } from "./pages/tender-awards/components/edit-award-modal/edit-award-modal.component";
import { TenderBidsTableViewComponent } from './pages/tender-bids-table-view/tender-bids-table-view.component';
import { TenderEditModalComponent } from './pages/tender-invitation/components/tender-edit-modal/tender-edit-modal.component';
import { TenderOverviewComponent } from './pages/tender-overview/tender-overview.component';
import { SupplierCoverLetterResolver } from './routing/resolvers/suppliers-input-bid/supplier-cover-letter.resolver';
import { SupplierDocumentsResolver } from './routing/resolvers/suppliers-input-bid/supplier-documents.resolver';
import {
  SupplierTenderInvitationParticipantsResolver
} from "./routing/resolvers/suppliers-input-bid/supplier-tender-invitation-participants.resolver";
import {
  SupplierTenderInvitationResolver
} from "./routing/resolvers/suppliers-input-bid/supplier-tender-invitation.resolver";
import { SupplierUsersResolver } from "./routing/resolvers/suppliers-input-bid/supplier-users.resolver";
import { SupplyConditionsResolver } from './routing/resolvers/suppliers-input-bid/supply-conditions.resolver';
import { TenderBidAnalysisReportResolver } from "./routing/resolvers/tender-bid-analysis-report.resolver";
import { SupplierUsersService } from "./services/suppliers-input-bid/supplier-users/supplier-users.service";
import { TenderBidAnalysisReportService } from "./services/tender-bid-analysis-report/tender-bid-analysis-report.service";
import { TenderBidSubmitService } from "./services/tender-bid-submit/tender-bid-submit.service";
import { FlexRenderDirective } from "@tanstack/angular-table";


@NgModule({
  imports: [
        AwardCommentIconComponent,
    NgCommonModule,
    JftCommonModule,
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    RouterModule.forChild(buyerModuleRoutes),
    NgbModule,
    IndexesModule,
    AuthModule,

    BrowserModule,
    //HotTableModule,
    GeodataModule,
    //PlotlyViaWindowModule,
    DragDropModule,
    NgxPaginationModule,
    NgSelectModule,
    NgxSelectModule,
    NgApexchartsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    TenderAwardsSearchBarComponent,
    NgIconComponent,
    ErrorReviewGridComponent,
    SubmissionFooterComponent,
    SecureImagePipe,
    FlexRenderDirective
  ],
  declarations: [
    CreateTenderDetailsComponent,
    CreateTenderSuppliersComponent,
    CreateTenderReviewComponent,
    CreateTenderStepsComponent,
    CreateTenderComponent,
    TendersComponent,
    TendersListComponent,
    TenderSearchBarComponent,
    CreateTenderContractsComponent,

    ContractFormModalComponent,
    ProductServiceModalComponent,
    EditProductServiceModalComponent,
    CreateSupplierFormModalComponent,
    CreateSupplierFormComponent,
    CreateSupplierBunchFileModalComponent,
    CreateSupplierBunchTableModalComponent,
    AddInvitedSuppliersFormModalComponent,
    ContractsImportModalComponent,
    ContractsImportTableModalComponent,
    InputCurrentContractModalComponent,
    InvitationInfoModalComponent,
    InfoModalComponent,
    InfoModalTenderExistsComponent,
    TenderBidsComponent,
    TenderContractsAllComponent,
    TenderContractsAwaitingBidsComponent,
    TenderContractsAwaitingReviewComponent,
    TenderContractsExpiredComponent,
    TenderContractsAwardedComponent,
    TenderContractsCancelledComponent,
    TenderContractBidsAnalysisComponent,
    TenderContractBidsComponent,
    TenderInvitationComponent,
    TenderReportComponent,
    TenderReportsComponent,
    TenderEditModalComponent,
    TenderSuppliersComponent,
    TenderAwardsComponent,
    EditAwardModalComponent,
    TenderSupplierInputBidComponent,
    TenderComponent,
    TenderTabsComponent,
    TenderBidImportModalComponent,
    InvitationDocumentsListComponent,
    AwardCompleteModalComponent,
    TenderImportModalComponent,
    InternalNotesModalComponent,
    VaDisplaySettingsModalComponent,
    BidHideShowModalComponent,
    AddIndexModalComponent,
    RevisionViewSettingsModalComponent,
    RevisionModelSettingsModalComponent,




    DeleteTenderButtonComponent,
    ExtendRoundButtonComponent,
    ExtendTenderAllRoundsButtonComponent,
    LaunchNextRoundAllLocationsButtonComponent,
    AwardButtonComponent,
    EditContractConditionsBtnComponent,
    DeclineOfferButtonComponent,
    PlattsChartComponent,
    PlattsSpreadChartComponent,
    SpreadChartComponent,
    IndexDateRangeComponent,
    ChartIndexAnalyticsComponent,
    ContractNavbarComponent,
    TenderContractDashboardComponent,
    TenderContractDashboardSupplierComponent,
    TenderContractDashboardSupplierAwardedComponent,
    ContractDashboardComponent,
    RoundControlsComponent,
    SuppliersComponent,
    ImportContactsModalComponent,
    SupplierCreateRoutingComponent,
    SupplierTableRowComponent,
    InputBidStepsComponent,
    TenderBidsSearchBarComponent,
    TenderSuppliersSearchBarComponent,
    TenderAnalyticsSettingsComponent,
    CostOfCapitalComponent,
    TenderCurrentContractComponent,
    ConversionFactorsComponent,
    InputCurrentContractComponent,
    PaymentTermsComponent,
    TenderContractDashboardIndexAnalysisComponent,
    TenderContractDashboardIndexAnalysisGraphComponent,
    TenderContractDashboardIndexAnalysisYearsComponent,
    TenderContractDashboardIndexAnalysisListComponent,
    TenderNoteComponent,
    DifferentialInputComponent,
    AiportDeliveryMethodsComponent,
    IndexSearchComponent,
    ArgusIndexComponent,
    PlattsIndexComponent,
    PerUsageFeesComponent,
    GrossNetBillingComponent,
    RampLimitationsComponent,
    ChartIndexAnalyticsGraphComponent,
    TenderBidsTableViewComponent,
    TenderOverviewComponent,
    AwardedContractsComponent,
    RevisionTabModelsComponent,
    RevisionTabModelComponent,
    RevisionUnitsConversionComponent,
    RevisionCurrenciesConversionComponent,
    RevisionTendersComparisonComponent,
    RevisionFinalBaseAmountComponent,
    RevisionConversionParamsModalComponent,
    BidAnalysisReportComponent,
    BidFeeReportComponent,
    PdfBifAnalysisReportModalComponent,
    SealedTenderRedirectComponent,
  ],
  exports: [





  ],
  bootstrap: [],
  providers: [
    provideNgxMask(),
    TenderContractsService,
    TenderService,

    SuppliersService,
    TenderSuppliersService,
    TenderSupplierInvitationInfoService,
    ContractProductServiceService,
    TendersService,


    TenderBidsService,
    TenderContractBidsAnalysisService,
    TenderContractBidsDashboardService,
    TenderContractSuppliersService,
    TenderContractRoundService,
    TenderSupplierDocumentsService,
    TenderNoteService,
    TenderOfferNoteService,
    TenderContractExtendRoundService,
    TenderContractsAwardedService,
    TenderContractRoundIndexPriceAverageService,
    TenderContractRoundSupplierService,
    TenderAnalyticsSettingsService,
    TenderAnalyticsSettingsCurrencyRatesService,
    TenderContractsStatisticService,
    TenderDocumentsService,
    TenderXmlExportsService,
    TenderXmlImportsService,
    TenderImportsService,
    TenderLaunchingXlsExportService,
    TenderBidXlsImportService,
    TenderBidCopyToCurrentRoundService,
    TenderContractPlattsOffersService,
    TenderContractOffersService,
    TenderEditableFieldService,
    TenderBidHistoryService,
    TenderRevisionService,
    TenderReportService,
    TenderBidAnalysisReportService,
    ProposalService,

    TenderOffersService,

    SupplierSupplyConditionsService,
    SupplierUsersService,
    SupplierContractsService,
    SupplierBidService,
    SupplierContractService,


    AwardedContractsService,
    AwardedOffersService,
    TenderBidMockService,
    TenderBidSubmitService,
    AwardedOffersResolver,
    TenderContractsResolver,
    TenderListResolver,
    TenderResolver,
    TenderDocumentsResolver,
    SuppliersResolver,
    SupplierResolver,
    TenderSuppliersResolver,
    SuppliersTabsResolver,
    TenderCoverLetterResolver,
    TenderRequestedDocumentsResolver,
    TenderBidsResolver,
    TenderContractBidsDashboardResolver,
    TenderContractBidsAnalysisResolver,
    TenderContractResolver,
    TenderContractDashboardResolver,
    TenderContractSuppliersResolver,
    TenderContractRoundResolver,
    TenderContractRoundSupplierResolver,
    TenderAnalyticsLocationInputCurrentContractResolver,
    TenderContractsAllResolver,
    TenderContractsAwaitingBidsResolver,
    TenderContractsAwaitingReviewResolver,
    TenderContractsCancelledResolver,
    TenderContractsExpiredResolver,
    TenderContractsAwardedResolver,
    TenderContractsStatisticResolver,
    TenderLastRoundsSuppliersResolver,
    TenderBidHistoryResolver,
    TenderAnalyticsCostOfCapitalResolver,
    TenderAnalyticsCurrencyRatesResolver,
    TenderAnalyticsPaymentTermsResolver,
    TenderAnalyticsConversionFactorResolver,
    TenderAnalyticsInputCurrentContractResolver,
    TenderContractRoundIndexPriceAverageResolver,
    TenderDocumentsOfferDetailResolver,
    TenderCoverLetterOfferDetailResolver,
    TenderAnalyticsConversionFactor2Resolver,
    TenderUnitRatesResolver,
    TenderRevisionResolver,
    TenderBidAnalysisReportResolver,
    SupplierProposalResolver,
    SupplierDocumentsResolver,
    SupplierCoverLetterResolver,
    SupplierTenderInvitationResolver,
    SupplierTenderInvitationParticipantsResolver,
    TenderSupplierInputBidResolver,
    SupplyConditionsResolver,
    SupplierContractsResolver,
    SupplierBidResolver,
    SupplierContractResolver,
    SupplierRequestedDocumentsResolver,
    SupplierCommonDocumentsResolver,
    SupplierSubmittedContractsResolver,
    SupplierOfferBidResolver,
    SupplierUsersResolver,
    TenderOfferResolver,
    SupplierSkippedContractsResolver,
    TenderInvitedSupplierUsersResolver,
    AwardedContractsResolver,
    AwardedOffersResolver,
    TenderStepGuard,
    TenderStatusGuard,
    NewRoundGuard,
    ProposalStepGuard,
    SupplierCoverLetterService
  ]
})

export class BuyerModule {
}
